import api from '../../../App/socket';

export const createLeadFinance = params => (
    api.send({
        api: 'db',
        model: 'Lead_finance',
        action: params.action,
        options: {
            create: params.create,
            update: params.update,
            where: params.where,
        },
    })
        .then(response => response)
        .catch(error => error)
);


export const readLeadFinance = params => (
    api.send({
        api: 'db',
        model: 'Lead_finance',
        action: 'Read',
        options: {
            limit: 1,
            attributes: 'all',
            include: {
                model: 'User',
                path: 'bought_info.bought_by_driver',
                attributes: ['person.first_name', 'person.last_name'],
            },
            where: {
                ref_lead: params.lead_id,
            },
        },
    })
        .then(response => response)
        .catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/lead_finance_request.js